import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface Lead {
  id?: string;
  full_name: string;
  email: string;
  whatsapp: string;
  company_name: string;
  leads_per_month: number;
  new_clients_per_month: number;
  average_project_value: number;
  marketing_investment: number;
  total_acquisition_costs: number;
  created_at?: string;
}

export async function saveLead(leadData: Omit<Lead, 'id' | 'created_at'>) {
  try {
    const { data, error } = await supabase
      .from('leads')
      .insert(leadData)
      .select()
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error saving lead:', error);
    throw error;
  }
}